import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { getBaseCreditDefaultValues } from './baseCredit';

export const getLeasingDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    ...getBaseCreditDefaultValues(attribution),
    datumLetzteRate: null,
    rateMonatlich: null,
    schlussrate: null,
    zinssatz: null,
});
